import { Component } from "react";
import { Link } from "react-router-dom";
import { WarningOctagon, ArrowClockwise, House } from "@phosphor-icons/react";

/**
 * Top-level error boundary. Catches any uncaught render/effect error so a single
 * page bug never blanks the entire app.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    console.error("[PerCen360] Uncaught error:", error, info);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen aurora flex items-center justify-center px-6">
        <div className="glass rounded-2xl px-10 py-10 text-center max-w-md" data-testid="error-boundary">
          <WarningOctagon size={40} weight="duotone" color="#FFB020" className="mx-auto mb-4"/>
          <div className="eyebrow mb-3">Something didn&apos;t load</div>
          <div className="font-display text-2xl mb-2">We hit a snag rendering this page.</div>
          <div className="text-white/60 text-sm mb-6">The error has been logged. Try reloading — if it persists, contact gillian@percen360.com.</div>
          <div className="flex justify-center gap-3">
            <button onClick={() => window.location.reload()} className="btn-gold text-sm"><ArrowClockwise size={14} weight="bold"/> Reload</button>
            <Link to="/" onClick={() => this.setState({ error: null })} className="btn-ghost text-sm"><House size={14}/> Home</Link>
          </div>
        </div>
      </div>
    );
  }
}
